import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AcessoExternoRouterService
{
    constructor(private router: Router) {}
}
